import { ApiService } from "@/services/ApiService";
import { useEffect, useState } from "react";
import Table from "@/components/Table";
import { t } from "i18next";
import { useAuth } from "@/contexts/Auth";
import { checkHasPermission } from "@/lib/permissions";
import { useNavigate } from "react-router-dom";

const Users = () => {
  const [apiData, setApiData] = useState<any>([]);
  const { get } = ApiService;
  const { usuario } = useAuth();
  const navigate = useNavigate();

  const columns = [
    {
      header: t("table.user.head.name"),
      accessor: "nome",
    },
    {
      header: "E-mail",
      accessor: "email",
    },
    {
      header: t("table.user.head.profile"),
      accessor: "perfil",
    },
    {
      header: t("table.user.head.active"),
      accessor: "status",
    },
  ];
    const allowedActions = [];
  if (checkHasPermission(usuario?.permissoes, "ROLE_USUARIO_EDITAR")) {
    allowedActions.push("editar");
  }
  if (checkHasPermission(usuario?.permissoes, "ROLE_USUARIO_DELETAR")) {
    allowedActions.push("remover");
  }

  const canAddNewUser = checkHasPermission(usuario?.permissoes, "ROLE_USUARIO_REGISTRAR");


  useEffect(() => {
    const fetch = async () => {
      const { data } = await get("api/v1/usuario/listar");
      setApiData(data);
    };

    fetch();
  }, []);

  return (
    <div className="flex-1 overflow-hidden p-8 max-md:px-4">
      <div className="mb-8 border-b pb-4">
        <h1 className='text-3xl font-medium mb-8'>{t("usersPage.title")}</h1>
      </div>
      {apiData && (
        <Table
          entity="usuario"
          baseRoute="api/v1/usuario"
          allowedActions={allowedActions}
          search={true}
          columns={columns}
          defaultData={apiData}
          buttonLabel={t("table.user.btn.add")}
          onButtonClick={() => navigate("registrar-usuario")}
          isButtonDisabled={!canAddNewUser}
        />
      )}
    </div>
  );
};

export default Users;